export const fromRentingAdToCardThumbnailContract = ({ad, i18n}) => {
  if (!ad) return

  return {
    badgeText: [i18n.t('COMMON.RENTING')],
    description: ad.title,
    imageUrl: ad.imgUrl,
    isLabelSpaceReserved: true,
    title: i18n.t('COMMON.MONTHLY_FEE', {
      amount: i18n.c(ad.monthlySubscriptionFee)
    }),
    url: ad.url
  }
}
export const fromNewAdToCardThumbnailContract = ({ad, i18n}) => {
  if (!ad) return

  const isFinanced = Boolean(ad.isFinanced)
  const price = ad.price

  return {
    badgeText: ad.offerType.literal,
    description: ad.title,
    ...(isFinanced
      ? {
          label: `${i18n.t('COMMON_FINANCED')}: ${i18n.c(ad.financedPrice)}`
        }
      : {isLabelSpaceReserved: true}),
    imageUrl: ad.imgUrl,
    title: i18n.c(price),
    url: ad.url
  }
}
